export default __webpack_public_path__ + "static/media/th.d3dea0ce.svg";